import * as React from "react";
import cx from "classnames";
import style from "./History.css";

import IconHistory from "./icons/History.svg";
import IconPeople from "./icons/People.svg";
import IconFocus from "./icons/Focus.svg";
import IconMission from "./icons/Mission.svg";

import substrate from "_images/shape.svg";
import shape from "_images/shape1.svg";

import { adjustLine } from "./utils";
import { ShapeGrey } from "components/Shape";

const Line = props => (
  <div
    ref={props._ref}
    className={cx(style.line, style.hideMobile)}
    data-wow-offset={200}
  >
    <span
      className={cx(style.innerLine, "wow", props.animation)}
      data-wow-duration="1s"
    />
  </div>
);

export class History extends React.Component {
  constructor(props) {
    super(props);

    this.items = [];
    this.lines = [];
  }

  adjustLines() {
    let c = 0;

    for (let i = 0; i < this.items.length; i += 1) {
      if (!this.items[i] || !this.items[i + 1] || !this.lines[c]) {
        break;
      }
      adjustLine(this.items[i], this.items[i + 1], this.lines[c++]);
    }
  }

  componentDidMount() {
    this.adjustLines();
    setTimeout(() => this.adjustLines(), 10);
    window.addEventListener("resize", () => this.adjustLines());
  }

  renderLines() {
    const liens = [];

    for (let i = 0; i < 17; i++) {
      liens.push(
        <Line
          key={i}
          _ref={c => this.lines.push(c)}
          animation={i ? "slideInDown" : "slideInUp"}
        />
      );
    }

    return liens;
  }

  render() {
    return (
      <section className={style.root}>
        <ShapeGrey className={style.shape1} animate="rotation slow" />
        <ShapeGrey className={style.shape2} animate="rotation slow" />
        <ShapeGrey className={style.shape3} animate="rotation slow" />
        <ShapeGrey className={style.shape4} animate="rotation slow" />
        <ShapeGrey className={style.shape5} animate="rotation slow" />
        <ShapeGrey className={style.shape6} animate="rotation slow" />

        <div className={cx(style.bg, style.bgTop)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 1920 622"
          >
            <path
              fill="#130F40"
              d="M1501 .6c-.8.2-224.7 15.3-497.5 33.4-393 26.2-499.6 33.5-513.3 35.5-148.5 21.6-278.7 108.7-349.7 234-3.8 6.6-36.9 74.1-73.7 149.9L0 591.4V622h1920V232.3l-11-16.3c-20.4-30.1-37-50.6-60.5-74.9C1780.9 71.6 1698.6 25.7 1609 7.6c-26.1-5.3-41.3-6.7-75-7.1-17.3-.2-32.2-.2-33 .1z"
            />
          </svg>
        </div>

        <div className={cx(style.bg, style.bgBottom)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 1920 318"
          >
            <path
              fill="#130F40"
              d="M0 45.9v45.8l15.8.7c38.3 1.5 67.9 1.7 111.2.7 158.7-3.5 159-3.5 192.2-2.3 51.9 2 52.2 2.1 143.3 21.7 482.9 104.3 888.7 191.7 895.5 192.9 59.7 11 130.6 9.1 192.5-5 74.6-17 144.1-51.3 201-99.3 18.5-15.6 34.5-32.5 100.6-106.3L1920 19V0H0v45.9z"
            />
          </svg>
        </div>

        <img
          ref={c => (this.items[0] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape7,
            "wow rotationIn faster"
          )}
          data-wow-offset={200}
          src={substrate}
        />

        <img
          ref={c => (this.items[1] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape8,
            "wow rotationIn fast"
          )}
          data-wow-offset={200}
          src={substrate}
        />

        <img
          ref={c => (this.items[3] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape9,
            "wow rotationIn"
          )}
          data-wow-offset={200}
          src={substrate}
        />

        <img
          ref={c => (this.items[4] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape10,
            "wow rotationIn"
          )}
          data-wow-offset={200}
          src={substrate}
        />
        <img
          ref={c => (this.items[5] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape11,
            "wow rotationIn"
          )}
          data-wow-offset={200}
          src={substrate}
        />
        <img
          ref={c => (this.items[7] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape12,
            "wow rotationIn"
          )}
          data-wow-offset={200}
          src={substrate}
        />
        <img
          ref={c => (this.items[8] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape13,
            "wow rotationIn"
          )}
          data-wow-offset={200}
          src={substrate}
        />
        <img
          ref={c => (this.items[10] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape14,
            "wow rotationIn"
          )}
          data-wow-offset={200}
          src={substrate}
        />
        <img
          ref={c => (this.items[11] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape15,
            "wow rotationIn"
          )}
          data-wow-offset={200}
          src={substrate}
        />
        <img
          ref={c => (this.items[12] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape16,
            "wow rotationIn"
          )}
          data-wow-offset={200}
          src={substrate}
        />
        <img
          ref={c => (this.items[13] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape17,
            "wow rotationIn"
          )}
          data-wow-offset={200}
          src={substrate}
        />
        <img
          ref={c => (this.items[14] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape18,
            "wow rotationIn"
          )}
          data-wow-offset={200}
          src={substrate}
        />
        <img
          ref={c => (this.items[16] = c)}
          className={cx(
            style.shape,
            style.hideMobile,
            style.shape19,
            "wow rotationIn"
          )}
          data-wow-offset={200}
          src={substrate}
        />

        <div className={style.content}>
          <div className="container">
            <ul className={style.list}>
              <li className={cx(style.item)}>
                <div className={style.itemContent}>
                  <h2 className={cx(style.itemHeader, "wow fadeInUp")}>
                    Our History
                  </h2>
                  <p className={cx(style.itemDesc, "wow fadeInUp")}>
                  BlockScience was founded in the fall of 2017 by Dr. Michael Zargham who felt that the interdisciplinary study of systems engineering as applied to socio-technical and economic systems needed to break out of academia and find its place amongst the increasingly digital real-world businesses migrating from static enterprise systems to dynamic and networked ecosystems.
                  </p>
                  <p
                    className={cx(style.itemDesc, "wow fadeInUp")}
                    data-wow-offset={200}>
                    <a
                      href="/history"
                    >
                      Learn More
                    </a>
                  </p>
                </div>
                <div ref={c => (this.items[2] = c)} className={style.itemIcon}>
                  <div
                    className={cx(style.wrap, "wow rotateIn")}
                    data-wow-delay="0.75s"
                    data-wow-offset={200}
                  >
                    <img
                      className={cx(style.itemShape, "rotation slow")}
                      src={substrate}
                    />
                    <img
                      className={style.icon}
                      src={IconHistory}
                      alt="Our History"
                    />
                  </div>
                </div>
              </li>

              <li className={cx(style.item)}>
                <div ref={c => (this.items[9] = c)} className={style.itemIcon}>
                  <div
                    className={cx(style.wrap, "wow rotateIn")}
                    data-wow-delay="0.25s"
                    data-wow-offset={200}
                  >
                    <img
                      className={cx(style.itemShape, "rotation slow")}
                      src={substrate}
                      alt="shape"
                    />
                    <img
                      className={style.icon}
                      src={IconPeople}
                      alt="Our People"
                    />
                  </div>
                </div>
                <div className={style.itemContent}>
                  <h2
                    className={cx(style.itemHeader, "wow fadeInUp")}
                    data-wow-offset={200}
                  >
                    Our People
                  </h2>
                  <p
                    className={cx(style.itemDesc, "wow fadeInUp")}
                    data-wow-offset={200}
                  >
                    Our team is interdisciplinary, with engineering teams operating in concert with social science and governance research teams of ethnographers and economists. Our unique blend of engineering, data science, and social science expertise enables us to provide a more holistic approach to solving algorithm design problems with complex human behavior implications. 
                    <p><a href="/team">Meet our Team</a></p>
                  </p>
                </div>
              </li>

              <li className={cx(style.item)}>
                <div className={style.itemContent}>
                  <h2
                    className={cx(style.itemHeader, "wow fadeInUp")}
                    data-wow-delay="0.25s"
                    data-wow-offset={200}
                  >
                    Our Mission
                  </h2>
                  <p
                    className={cx(style.itemDesc, "wow fadeInUp")}
                    data-wow-delay="0.25s"
                    data-wow-offset={200}
                  >
                    The mission of BlockScience is to bridge the digital and physical worlds through innovative and sustainable engineering. We guide the development and governance of safe, ethical, and resilient socio-technical systems, leveraging emerging technologies to solve complex problems.
                  </p>
                </div>
                <div ref={c => (this.items[15] = c)} className={style.itemIcon}>
                  <div
                    className={cx(style.wrap, "wow rotateIn")}
                    data-wow-offset={200}
                  >
                    <img
                      className={cx(style.itemShape, "rotation slow")}
                      src={substrate}
                    />
                    <img
                      className={style.icon}
                      src={IconMission}
                      alt="Our Mission"
                    />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div
          className={cx(style.research, "wow rotateIn")}
          data-wow-offset={200}
          data-wow-delay="0.25s"
        >
          <img
            className={cx(style.background, "rotation slower")}
            src={substrate}
          />
          <div className={style.researchContent}>
            <p>
              “With a focus on community driven goals rather than financial profit, BlockScience is unique in that for the first time, non-profit and humanitarian organizations like the Red Cross can engage world class engineers and data scientists to design, develop, and deploy complex models that leverage machine learning and AI to address some of our most fundamental challenges focused on saving lives and enhancing resilience.”
            </p>
            <span className={style.name}>Adam Bornstein</span>
            <span>Lead, Innovative Finance &amp; Systems Change, Danish Red Cross</span>
          </div>
        </div>

        <div className={style.bgTest} />
      </section>
    );
  }
}
